export const faqs = [
  {
    question: 'mm131 是一个什么样的平台？',
    answer: 'mm131 是国内知名的高清美女写真图库平台，汇聚海量精选写真套图、模特图集与时尚摄影资源。我们致力于为摄影爱好者、设计师和视觉内容创作者提供高品质的图片素材和灵感。平台内容涵盖性感写真、清纯美女、时尚街拍、私房摄影、日系写真、韩系风格等多个分类，每日更新最新套图。',
  },
  {
    question: 'mm131 的图片资源可以免费使用吗？',
    answer: 'mm131 平台上的所有图片资源仅供个人欣赏和灵感参考使用。如需将图片用于商业用途，请先联系版权方获取授权。我们尊重每一位摄影师和模特的创作成果，坚决维护知识产权。部分标注为"免费素材"的图片可在遵守使用条款的前提下用于非商业项目。',
  },
  {
    question: '如何快速找到我想要的写真内容？',
    answer: '您可以通过以下几种方式快速浏览目标内容：1) 使用顶部的分类导航栏，按写真类型（如性感写真、清纯美女、日系写真等）筛选浏览；2) 在搜索框中输入关键词（如模特名称、拍摄风格、场景主题等）进行精准搜索；3) 在首页浏览"热门推荐"和"最新套图"板块，获取当下最受欢迎的内容；4) 收藏本页入口，随时直达最新内容。',
  },
  {
    question: 'mm131 的内容更新频率是怎样的？',
    answer: 'mm131 保持每日更新的频率，我们的编辑团队每天精选最新、最优质的写真套图资源上传至平台。同时，每周会推出专题合集和热门模特特辑，为用户提供更丰富的内容体验。建议您收藏本页或关注我们的社交媒体账号，第一时间获取最新内容推送。',
  },
  {
    question: '我想成为 mm131 的签约模特，应该如何申请？',
    answer: '我们欢迎有潜力的模特加入 mm131 大家庭。申请流程如下：1) 准备您的个人资料和代表作品（至少5张高清照片）；2) 通过"关于我们"页面的联系方式发送申请邮件，主题注明"模特申请"；3) 我们的经纪团队会在3-5个工作日内进行审核，通过后将与您联系安排试镜。要求：年满18周岁，形象气质佳，有良好的镜头表现力。',
  },
  {
    question: '在移动设备上浏览 mm131 体验如何？',
    answer: 'mm131 网站采用响应式设计，完美适配手机、平板和桌面电脑等多种设备。无论在何种屏幕上浏览，都能获得流畅、清晰的视觉体验。我们特别优化了移动端的图片加载速度和交互体验，让您随时随地享受高清写真的视觉盛宴。',
  },
  {
    question: 'mm131 对内容安全有什么保障措施？',
    answer: 'mm131 严格遵守国家相关法律法规和互联网内容管理规范。所有平台内容均经过人工审核，确保符合社会主义核心价值观和公序良俗要求。我们建立了完善的内容审核机制，对违规内容零容忍。同时，我们采用先进的加密技术保护用户隐私和数据安全。',
  },
];